import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { HarvestTypes, PlantsEnum, SupplierTypeEnum } from '@gtpl/shared-models/common-models';
import { CommissionType, HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
import { IndentItemsModel } from './indent-items.model';
export class IndentDetailsDto {
    @ApiProperty()
    // @IsEnum(PlantsEnum)
    plantId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Indent Date should not be empty" })
    indentDate: Date;

    @ApiProperty({
        enum: SupplierTypeEnum
    })
    @IsNotEmpty({ message: "Supplier Type should not be empty" })
    @IsEnum(SupplierTypeEnum)
    supplierType: SupplierTypeEnum;

    @ApiProperty({
        enum: CommissionType
    })
    @IsNotEmpty({ message: "Commission Type should not be empty" })
    @IsEnum(CommissionType)
    commissionType: CommissionType;

    @ApiProperty()
    @IsNotEmpty({ message: "Commission should not be empty" })
    @IsNumber()
    commission: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Harvesting Date should not be empty" })
    harvestingDate: Date;

    @ApiProperty({
        enum: HarvestingTime
    })
    @IsNotEmpty({ message: "Harvesting Time should not be empty" })
    @IsEnum(HarvestingTime)
    harvestingTime: HarvestingTime;

    @ApiProperty()
    @IsNumber()
    indentBy: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Assignlead 1 should not be empty" })
    @IsNumber()
    assignLead1: number;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    assignLead2: number;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    indentId: number;

    @ApiProperty()
    @IsOptional()
    indentCode: string;

    @ApiProperty()
    @IsOptional()
    grnCompleted: boolean;

    @ApiProperty({
        enum: HarvestTypes
    })
    @IsNotEmpty({ message: "Supplier Type should not be empty" })
    @IsEnum(HarvestTypes)
    harvestType: HarvestTypes;
    @ApiProperty({ type: [IndentItemsModel] })
    indentItems: IndentItemsModel[];

    @ApiProperty()
    @IsOptional()
    createdUser: string;

    @ApiProperty()
    @IsOptional()
    isVehicleRequired: boolean;

    @ApiProperty()
    @IsOptional()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    isActive: boolean;
}